/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryExtraPresence extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryExtraPresence");
    }

    getFixupPrototypeFunction() { return ResourceQueryExtraPresence.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryExtraPresence>): ResourceQueryExtraPresence {
        let obj = Object.assign(new ResourceQueryExtraPresence(), model);
        ResourceQueryExtraPresence.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryExtraPresence>): ResourceQueryExtraPresence {
        if (!model) return null;
        return ResourceQueryExtraPresence.newInstance(<ResourceQueryExtraPresence> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryExtraPresence) {
        if (!obj) return;

        models.ResourceQueryExtraPresence.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryExtraPresence): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryExtraPresence.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against resources with or without extra dimensions
     */
    has_extras: boolean;

}
